export class LogMessageUtils {
  static validationFailed(scope: string): string {
    return `[${scope}] - Response validation failed:`;
  }

  static entriesFetchFailed(scope: string): string {
    return `[${scope}] - Error fetching entries:`;
  }

  static entryFetchFailed(scope: string): string {
    return `[${scope}] - Error fetching entry by ID:`;
  }
}
